import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ bgOurUnits }) => css`
    background: url(${bgOurUnits});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 1rem;
    color: black;
    min-height: 100vh;
    text-align: justify;
  `}
`;

export const DLBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  position: relative;
  margin-bottom: 3rem;
  font-size: 1rem;
  color: black;
  width: 40rem;
  img {
    align-self: center;
    width: 6.688rem;
    max-width: 16rem;
    @media only screen and (min-width: 600px) {
      width: 15rem;
    }
    @media only screen and (min-width: 800px) {
      width: 16rem;
    }
  }
`;

export const RuralDescription = styled.div`
  display: flex;
  justify-content: center;
  height: 4rem;
  background-color: #006e2c;
  border-radius: 1rem;
  color: white;
  padding: 2rem;
`;

export const MidTitle = styled.div`
  display: flex;
  justify-content: center;
  color: #006e2c;
  font-size: 1.5rem;
  font-weight: bold;
  font-style: oblique 15deg;
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

export const PodcastDescription = styled.div`
  display: flex;
  justify-content: center;
  font-size: 1rem;
`;

export const SpotifyButtonBox = styled.div`
  a {}
`;

export const SintonizeBox = styled.div`
  display: flex;
  flex-direction: row;
  padding: 1rem;
  padding-left: 0.4rem;
  border-radius: 1rem;
  background-color: #ffffffff;
  box-shadow: 2px 2px 8px #b5b5b5ff;
  gap: 1rem;
  transition: box-shadow .2s ease, transform .2s ease, background-color .2s ease;
  cursor: pointer;
  &:hover {
    box-shadow: 4px 8px 20px rgba(0,0,0,.18);
    transform: translateY(-2px);
    background-color: #f8fff9; /* opcional */
  }
`;

export const RadioItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 0.6rem;
  gap: 0.5rem;
`;

export const RadioInnerItem = styled.div`
`;

export const RadioItemTop = styled.div`
  font-size: 1.2rem;
`;

export const RadioItemDescription = styled.div`
  display: flex;
  justify-content: left;
  font-size: 0.5rem;
`;
